import { useRef, useCallback } from 'react';
import debounce from 'lodash/debounce';

const defaultSettings = {
    wait: 500 // ms
};

export default function useKeyDownAutoSelect({ wait } = defaultSettings) {
    const actionList = useRef([]);
    const timeoutRef = useRef(0);
    const textBuffer = useRef('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const addAction = useCallback(({ actions, value, text }) => {
        actionList.current.push({
            actions,
            value,
            text
        });
    });

    const onOpen = () => {
        actionList.current = [];
    };

    const clearDebounce = () => {
        if (timeoutRef.current && timeoutRef.current.cancel) {
            timeoutRef.current.cancel();
            timeoutRef.current = null;
        }
    };

    const clearBuffer = () => {
        textBuffer.current = '';
    };

    const addDebounce = () => {
        timeoutRef.current = debounce(() => {
            clearBuffer();
        }, wait);
    };

    const findMenuItem = () => {
        const expression = new RegExp(`^${textBuffer.current}`, 'i');
        const found = actionList.current.find(({ text }) =>
            expression.test(text)
        );

        if (found) {
            found.actions.focusVisible();
        }
    };

    const onKeyDown = e => {
        if (e.key.length !== 1) {
            return;
        }

        e.stopPropagation();
        textBuffer.current += e.key;

        findMenuItem();
        clearDebounce();
        addDebounce();
        timeoutRef.current();
    };

    return {
        onOpen,
        onKeyDown,
        addAction
    };
}
